/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthSocialLink } from '../../../../../../node_modules/@nebular/auth/auth.options.js';
import { NbAuthResult, NbAuthService } from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { environment } from '../../../../../environments/environment.js';
import { handoffRedirectUrl, redirectOnce } from '../../../../session-handoff';
import { Subscription } from 'rxjs';

@Component({
	selector: 'ngx-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxLoginComponent implements OnDestroy {

	private paramSub: Subscription;

	redirectDelay: number = 0;
	showMessages: any = {};
	strategy: string = '';

	errors: string[] = [];
	messages: string[] = [];
	user: any = {};
	subdomain = null;
	submitted: boolean = false;
	socialLinks: NbAuthSocialLink[] = [];
	rememberMe = false;

	constructor(
		private route: ActivatedRoute,
		protected service: NbAuthService,
		@Inject(NB_AUTH_OPTIONS) protected options = {},
		protected cd: ChangeDetectorRef,
		protected router: Router) {

		this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
		this.showMessages = this.getConfigValue('forms.login.showMessages');
		this.strategy = this.getConfigValue('forms.login.strategy');
		this.socialLinks = this.getConfigValue('forms.login.socialLinks');
		this.rememberMe = this.getConfigValue('forms.login.rememberMe');
		this.user.subdomain = this.getSubDomain();

		this.paramSub = this.route.params.subscribe(params => {
			this.user.subdomain = params['loginBusiness'];
			this.user.username = params['loginUsername'];
		});
	}

	@HostListener('window:UpdateLoginModel', ['$event', '$event.detail.nBusiness', '$event.detail.nUsername', '$event.detail.nPassword'])
	UpdateLoginModel(event, nBusiness, nUsername, nPassword) {
		this.user.subdomain = nBusiness;
		this.user.username = nUsername;
		this.user.password = nPassword;
		this.login();
	}

	login(): void {
		this.errors = this.messages = [];
		this.submitted = true;

		this.service.authenticate(this.strategy, this.user).subscribe((result: NbAuthResult) => {
			this.submitted = false;

			if (result.isSuccess()) {
				this.messages = result.getMessages();
				const token = result.getToken();
				const jwt = token ? token.getValue() : undefined;
				const handoff = handoffRedirectUrl(jwt, window.location.host, environment.sessionCookieDomain);
				if (handoff) { redirectOnce(handoff, environment.sessionCookieDomain); return; }
			} else {
				this.errors = result.getErrors();
			}

			const redirect = result.getRedirect();
			if (redirect) {
				setTimeout(() => {
					return this.router.navigateByUrl(redirect);
				}, this.redirectDelay);
			}
			this.cd.detectChanges();
		});
	}

	getConfigValue(key: string): any {
		return getDeepFromObject(this.options, key, null);
	}

	getSubDomain(): String {
		const subdomain = ((window.location.hostname).split('.'))[0];
		environment.customerShortname = (subdomain === '192' || subdomain === 'dashboard' || subdomain === 'localhost') ? environment.customerShortname : subdomain;

		return environment.customerShortname;
	}

	ngOnDestroy(): void {
		if (this.paramSub) { this.paramSub.unsubscribe(); }
	}
	
}
